<template>
  <div>
    <base-dropdown position="right" :disabled="!client.uuid">
      <base-button outline class="add-credits-btn" slot="title" :disabled="!client.uuid">
        <i class="nc-icon nc-simple-add text-default"></i>
      </base-button>
      <h6 class="dropdown-header">{{$t('generic.topUp')}}</h6>
      <div class="dropdown-item" @click="showCreditsModal = true">
        {{$t('generic.addCredits')}}
      </div>

      <div class="dropdown-item" @click="showContractsModal = true">
        {{$t('generic.addContracts')}}
      </div>

    </base-dropdown>

    <add-credits-modal v-if="showCreditsModal && client"
                       :show.sync="showCreditsModal"
                       :client="client"
                       @submit="addCredits">
    </add-credits-modal>
    <add-contracts-modal v-if="showContractsModal && client"
                         :show.sync="showContractsModal"
                         :client="client"
                         @submit="addContracts">
    </add-contracts-modal>
  </div>
</template>
<script>
  import CreditService from 'src/services/CreditService'
  import AddCreditsModal from 'src/views/admin/contacts/clients/ClientManagement/AddCreditsModal'
  import AddContractsModal from 'src/views/admin/contacts/clients/ClientManagement/AddContractsModal'
  import ContractService from 'src/services/ContractService'
  export default {
    components: {
      AddCreditsModal,
      AddContractsModal
    },
    props: {
      client: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        showCreditsModal: false,
        showContractsModal: false
      }
    },
    methods: {
      async addCredits (data) {
        await CreditService.create(data)
        this.showCreditsModal = false
        this.$emit('credits-add')
      },
      async addContracts (data) {
        await ContractService.create(data)
        this.showContractsModal = false
        console.log(data.client_id)
        this.$emit('contracts-add')
      }
    }
  }
</script>
<style scoped lang="scss">
  .text-default {
    color: $default-color;
  }
  .add-credits-btn {
    height: 40px;
    margin-left: 10px;
    &:hover,
    &:focus,
    &.active {
      i {
        color: white;
      }
    }
  }
</style>
